import React from "react";
import { Home, Key, Paintbrush, Building2 } from "lucide-react";
import { Overline, DiamondDivider } from "./Shared";
import { useReveal } from "../hooks/useReveal";

const ICONS = { Home, Key, Paintbrush, Building2 };

export const Services = ({ t }) => {
  const s = t.services;
  const { ref, visible } = useReveal();

  return (
    <section id="services" data-testid="services-section" className="relative py-24 sm:py-32 bg-aa-surface">
      <div ref={ref} className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className={`text-center max-w-2xl mx-auto reveal ${visible ? "is-visible" : ""}`}>
          <Overline>{s.overline}</Overline>
          <h2 className="font-heading font-light text-aa-cream mt-5 text-3xl sm:text-4xl lg:text-5xl tracking-tight">
            {s.title}
          </h2>
          <p className="font-body font-light text-aa-cream/65 mt-5 text-base sm:text-lg">{s.subtitle}</p>
          <DiamondDivider className="mt-8" />
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-aa-gold/20 border border-aa-gold/20">
          {s.items.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className={`group bg-aa-surface p-8 lg:p-10 transition-all duration-500 hover:bg-aa-green reveal ${
                  visible ? "is-visible" : ""
                }`}
                style={{ transitionDelay: `${i * 0.1}s` }}
              >
                <div className="w-14 h-14 flex items-center justify-center border border-aa-gold/30 text-aa-gold group-hover:bg-aa-gold group-hover:text-aa-green transition-colors duration-500">
                  {Icon && <Icon size={26} strokeWidth={1} />}
                </div>
                <h3 className="font-heading text-lg sm:text-xl text-aa-cream mt-7 font-medium leading-snug">
                  {item.title}
                </h3>
                <p className="font-body font-light text-aa-cream/60 mt-4 text-sm leading-relaxed">
                  {item.desc}
                </p>
                <div className="mt-6 h-px w-8 bg-aa-gold/50 group-hover:w-full transition-all duration-500" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
